import { useQuery } from '@tanstack/react-query';
import { getAllSettings } from '@services/settings';

export const SETTINGS_QUERY_KEY = ['settings'];

export const useSettings = () => {
  return useQuery({
    queryKey: SETTINGS_QUERY_KEY,
    queryFn: getAllSettings,
    staleTime: 5 * 60 * 1000,
  });
};

export default useSettings;
